export default __webpack_public_path__ + "static/successImage3-7134500fba659c4689e7ba2ac94777d2.png";